<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiClockTimeFourOutline } from "@mdi/js";
export default {
  name: "MdiClockTimeFourOutline",
  data() {
    return {
      svgPath: mdiClockTimeFourOutline,
    };
  },
};
</script>
